import { render, staticRenderFns } from "./ProviderTitle.vue?vue&type=template&id=3a1ef228&scoped=true&"
import script from "./ProviderTitle.vue?vue&type=script&lang=js&"
export * from "./ProviderTitle.vue?vue&type=script&lang=js&"
import style0 from "./ProviderTitle.vue?vue&type=style&index=0&id=3a1ef228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1ef228",
  null
  
)

export default component.exports